import { Attr, BelongsTo, Model } from "spraypaint";
import ApplicationRecord from "./ApplicationRecord";
import Recruiter from "./Recruiter";

@Model()
class ActiveSubscription extends ApplicationRecord {
  static jsonapiType = "active_subscriptions";

  @Attr() startDate: string;

  @BelongsTo(Recruiter) owner: Recruiter;
}

export default ActiveSubscription;
